<template>
  <div class="reviews-page">
    <div class="page-title">
      <h1>Review Campaigns</h1>
      <p>Manage review programs, track growth, and monitor conversions.</p>
    </div>
    <!-- ===== METRICS STRIP ===== -->
    <div class="metrics-grid">

      <div class="metric-card">
        <div class="metric-head">
          <span>Total Created</span>
          <span class="material-symbols-outlined primary">send</span>
        </div>
        <div class="metric-value">
          {{ kpis.total_sent }}
        </div>
      </div>

      <div class="metric-card">
        <div class="metric-head">
          <span>Reviews</span>
          <span class="material-symbols-outlined primary">star</span>
        </div>
        <div class="metric-value">
          {{ kpis.avg_open_rate }}
        </div>
      </div>

      <div class="metric-card">
        <div class="metric-head">
          <span>Active Campaigns</span>
          <span class="material-symbols-outlined warning">bolt</span>
        </div>
        <div class="metric-value">
          {{ kpis.active_campaigns }}
        </div>
      </div>

      <div class="metric-card">
        <div class="metric-head">
          <span>Positive</span>
          <span class="material-symbols-outlined primary">trending_up</span>
        </div>
        <div class="metric-value">
          {{ kpis.conversions }}
        </div>
      </div>

    </div>

    <!-- ===== TOOLBAR ===== -->
    <div class="toolbar">

      <div class="toolbar-left">

        <div class="search-box">
          <span class="material-symbols-outlined">search</span>
          <input v-model="searchQuery" placeholder="Search campaigns..." />
        </div>

        <!-- Type Dropdown -->
        <!-- <div class="dropdown-wrapper">
          <button id="typeBtn" class="filter-btn" @click="toggleTypeDropdown">
            <span class="material-symbols-outlined">category</span>
            Type: {{ selectedType }}
            <span class="material-symbols-outlined">expand_more</span>
          </button>

          <div id="typeDropdown" v-if="activePopup === 'type'" class="dropdown-menu">
            <div @click="selectType('All')">All Campaigns</div>
            <div @click="selectType('Review')">Review Campaigns</div>
            <div @click="selectType('Referral')">Referral Campaigns</div>
          </div>
        </div> -->

        <!-- Status Dropdown -->
        <div class="dropdown-wrapper">
          <button id="statusBtn" class="filter-btn" @click="toggleStatusDropdown">
            <span class="material-symbols-outlined">toggle_on</span>
            Status: {{ selectedStatus }}
            <span class="material-symbols-outlined">expand_more</span>
          </button>

          <div id="statusDropdown" v-if="activePopup === 'status'" class="dropdown-menu">
            <div @click="selectStatus('All')">All Status</div>
            <div @click="selectStatus('Active')">Active</div>
            <div @click="selectStatus('Paused')">Paused</div>
          </div>
        </div>

      </div>

      <div class="toolbar-right">

        <button @click="expNow()" class="ghost-btn">
          <span class="material-symbols-outlined">download</span>
          Export
        </button>

        <button @click="add_camp()" class="primary-btn">
          <span class="material-symbols-outlined">add</span>
          Create Campaign
        </button>

      </div>

    </div>

    <!-- ===== TABLE ===== -->
    <div class="table-card">

      <table>
        <thead>
          <tr>
            <th>Campaign</th>
            <th>Status</th>
            <th>Reviews</th>
            <th class="right">Actions</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="camp in campaigns" :key="camp.camp_id">

            <!-- Campaign Cell -->
            <td>
              <div class="campaign-cell">

                <div class="campaign-icon" :class="camp.camp_cat.toLowerCase()">
                  <span class="material-symbols-outlined">
                    {{ camp.camp_cat === 'Review' ? 'star' : 'group' }}
                  </span>
                </div>

                <div class="campaign-info">
                  <div class="campaign-name">{{ camp.camp_title }}</div>
                  <div class="campaign-meta">
                    Date {{ camp.camp_datetime }}
                  </div>
                </div>

              </div>
            </td>

           

            <!-- Status -->
            <td>
              <span :class="['status-pill', camp.camp_status]">
                {{ camp.camp_status }}
              </span>
            </td>

            <!-- Funnel -->
            <td>
              <span class="status-pill active" style="margin-left: 1rem;">
                Positive: {{ camp.positives }}
              </span>
              <span class="status-pill paused" style="margin-left: 1rem;">
                Negative: {{ getNeg(camp.reviews,camp.positives) }}
              </span>
            </td>


            <!-- Actions -->
            <td style="text-align: left;">
              <!-- <button class="mini-btn" @click="toggleMenu(camp.id)">•••</button> -->
              <div class="actions-inline">
                <button @click="shareLink(camp.camp_id)" class="icon-btn" title="Share Link">
                  <span class="material-symbols-outlined">share</span>
                </button>
                <button @click="copyLink(camp.camp_id)" class="icon-btn" title="Copy Link">
                  <span class="material-symbols-outlined">content_copy</span>
                </button>
                <button @click="embedLink(camp.camp_id)" class="icon-btn" title="Embed Script">
                  <span class="material-symbols-outlined">link</span>
                </button>
                <button @click="showQR(camp.camp_id)" class="icon-btn" title="Download QR">
                  <span class="material-symbols-outlined">qr_code</span>
                </button>
                <button 
                    @click="changeStatus(camp,camp.camp_status==='active'?'paused':'active')" 
                    class="icon-btn"
                    :title="camp.camp_status === 'active' ? 'Pause Campaign' : 'Activate Campaign'"
                  >
                  <span class="material-symbols-outlined">
                  {{ camp.camp_status === 'active' ? 'pause_circle' : 'play_circle' }}
                  </span>
                </button>
                <button
                  class="dot-btn"
                  @click="toggleMenu(camp.camp_id)"
                >
                  <span class="material-symbols-outlined">
                    more_vert
                  </span>
                </button>
                <div
                  v-if="activeMenuPopup === camp.camp_id"
                  class="actions-menu"
                  style="text-align: left;"
                >
                  <div @click="viewLeads(camp.camp_id)" 
                    style="text-align: center; align-items: center;">
                    All Reviews
                  </div>
                   <div @click="editCamp(camp.camp_id)" 
                    style="text-align: center; align-items: center;">
                    Edit Campaign
                  </div>
                  <div @click="delCamp(camp.camp_id)" 
                    style="text-align: center; align-items: center;">
                    Delete
                  </div>
                </div>
              </div>
            </td>

          </tr>
        </tbody>

      </table>
      <div class="pagination" v-if="totalCampaigns>10">

        Showing
        {{ page * pageSize + 1 }}
        –
        {{ Math.min((page + 1) * pageSize, totalCampaigns) }}
        of {{ totalCampaigns }} campaigns

        <div class="pages">

          <button @click="prevPage" :disabled="page === 0">
            ‹
          </button>

          <button class="active">
            {{ page + 1 }}
          </button>

          <button @click="nextPage" :disabled="page + 1 >= totalPages">
            ›
          </button>

        </div>

      </div>
    </div>
    <!-- ===== DELETE CONFIRM MODAL ===== -->
    <div v-if="showDeleteModal" class="modal-overlay">

      <div class="modal-box">

        <div class="modal-icon">
          <span class="material-symbols-outlined">delete</span>
        </div>

        <h3>Delete Campaign?</h3>

        <p>
          This action cannot be undone.
          All campaign data will be permanently removed.
        </p>

        <div class="modal-actions">
          <button class="ghost-btn" @click="cancelDelete">
            Cancel
          </button>

          <button class="danger-btn" @click="confirmDelete">
            Delete Campaign
          </button>
        </div>

      </div>
      <!-- ================= LEADS MODAL ================= -->

    </div>
    
      <div v-if="showLeadsModal" class="modal-overlay">

        <div class="modal-large">

          <div class="modal-header" style="display: flex;">
            <h3>Campaign Leads</h3>
            <button style="margin-left: 85%;" @click="showLeadsModal = false">✕</button>
          </div>

          <div class="modal-body">

            <table class="leads-table">

              <thead>
                <tr>
                  <th>Source</th>
                  <th>Customer</th>
                  <th>Rating (Star)</th>
                  <th>Email | Phone</th>
                  <th style="width: 5rem;">Date|Time</th>
                  <th>customer Feedback</th>
                </tr>
              </thead>

              <tbody>

                <tr v-if="loadingLeads">
                  <td colspan="5">Loading...</td>
                </tr>

                <tr v-for="lead in leads" :key="lead.review_id">

                  <td>{{ lead.review_platform }}</td>
                  <td>{{ lead.review_name }}</td>
                  <td>{{ lead.review_rating }}</td>
                  <td>{{ lead.review_email }}<span v-if="lead.review_mobile.length>0"> | {{ lead.review_mobile }}</span></td>
                  <td>{{ beautifyDate(lead.review_datetime) }}</td>

                  <td>
                    <span v-if="showTxt!=lead.review_id">{{ getShrt(lead.review_feedback) || "-"}}</span>
                    <span v-if="showTxt===lead.review_id">{{ lead.review_feedback || "-"}}</span>
                    <a style="margin-left: 1rem;" v-if="showTxt!=lead.review_id && lead.review_feedback.length>100" @click="readMore(lead.review_feedback,lead.review_id,1)">Read More</a>
                    <a style="margin-left: 1rem;" v-if="showTxt===lead.review_id && lead.review_feedback.length>100" @click="readMore(lead.review_feedback,lead.review_id,0)">Read Less</a>
                  </td>
                </tr>

              </tbody>

            </table>

          </div>

          <!-- Pagination -->
          <div class="modal-pagination">

            <button @click="prevLeadsPage" :disabled="leadsPage === 0">
              ‹
            </button>

            <span>
              Page {{ leadsPage + 1 }} of {{ leadsTotalPages }}
            </span>

            <button
              @click="nextLeadsPage"
              :disabled="leadsPage + 1 >= leadsTotalPages"
            >
              ›
            </button>

          </div>

        </div>

      </div>

  </div>
</template>
<script>
   import QRCode from "qrcode";
  import {
    getCampaignList,
    getCampaignKpiStats,
    updateCampaignStatus,
    delCampNow
  } from "../apis/campaignapis";
   import {
    getReviewList
  } from "../apis/reviewapis";

  import {
    getQrUrl
  } from "../apis/qrapis";
  import {
    mainBaseUrl,apiBaseUrl
  } from "../apis/appconst";
  import { useToast } from "vue-toastification";


  export default {

    data() {
      return {
        showTxt:"",
        tmpTxt:"",
        confirmDeleteId: null,
        showDeleteModal: false,
        camp_user: "",
        toast:null,
        activePopup: null,
        activeMenuPopup: null,
        showLeadsModal: false,
        leads: [],
        leadsPage: 0,
        leadsPageSize: 10,
        totalLeads: 0,
        activeCampForLeads: null,
        loadingLeads: false,

        /* KPI DATA */
        kpis: {
          total_sent: 0,
          avg_open_rate: "0%",
          active_campaigns: 0,
          conversions: "0%"
        },

        searchQuery: "",

        selectedType: "All",
        selectedStatus: "All",

        campaigns: [],
        page: 0,
        pageSize: 10,
        totalCampaigns: 0
      };
    },

    async mounted() {
      this.toast = useToast();
      const tmp = sessionStorage.getItem("ldata") || "";
      if (tmp && tmp.length > 0) {
        this.camp_user = JSON.parse(tmp).user_id;
      }
      document.addEventListener("click", this.handleOutsideClick);

      await this.loadKpis();
      await this.loadCampaigns();
    },

    beforeUnmount() {
      document.removeEventListener("click", this.handleOutsideClick);
    },

    watch: {
      searchQuery() {
        this.page = 0;
        this.debouncedSearch();
      }
    },

    created() {
      this.debouncedSearch = this.debounce(this.loadCampaigns, 400);
    },

    computed: {
      totalPages() {
        return Math.ceil(this.totalCampaigns / this.pageSize);
      },
      
    },

    methods: {
      readMore(tmptxt,id,rtype){
        if(rtype===1){
          this.tmpTxt = tmptxt;
          this.showTxt = id;
        }
        else{
           this.tmpTxt = "";
          this.showTxt = "";
        }
      },
      getShrt(tmptxt){
        if(tmptxt.length>100){
           return (tmptxt+"").substring(0,100)+"...";
        }
        return tmptxt;
      },
      beautifyDate(datetime) {
        if (!datetime) return "";

        const date = new Date(datetime.replace(" ", "T"));

        return date.toLocaleString("en-IN", {
          day: "numeric",
          month: "short",
          year: "numeric",
          hour: "numeric",
          minute: "2-digit"
        });
      },
      nextLeadsPage() {
        if (this.leadsPage + 1 >= this.leadsTotalPages) return;
        this.loadLeads(this.leadsPage + 1);
      },

      prevLeadsPage() {
        if (this.leadsPage === 0) return;
        this.loadLeads(this.leadsPage - 1);
      },
      async viewLeads(camp_id) {

        this.activeCampForLeads = camp_id;
        this.leadsPage = 0;
        this.showLeadsModal = true;
        this.activeMenuPopup = null;

        await this.loadLeads();

      },
      async loadLeads(page = this.leadsPage) {

        if (!this.activeCampForLeads) return;

        this.loadingLeads = true;
        this.leadsPage = page;

        // 🔥 Replace with your actual API
        const res = await getReviewList(
          "","",
          this.activeCampForLeads,
          "",[],"",
          page
        );

        if (!res.status) {
          this.loadingLeads = false;
          return;
        }

        this.leads = res.reviews || [];
        this.totalLeads = parseInt(res.total+"" || 0);

        this.loadingLeads = false;
      },
      
      editCamp(camp_id){
        window.location.href = "/campaign/new?campId="+camp_id;
      },
      delCamp(camp_id) {
        this.confirmDeleteId = camp_id;
        this.showDeleteModal = true;
        this.activeMenuPopup = null;
      },
      async confirmDelete() {

      const res = await delCampNow(
          this.confirmDeleteId
        );

        if (!res.status) return;

      this.showDeleteModal = false;
      this.confirmDeleteId = null;
      this.loadCampaigns();
    },
    cancelDelete() {
      this.showDeleteModal = false;
      this.confirmDeleteId = null;
    },
       expNow(){
       const status =
          this.selectedStatus === "All"
            ? ""
            : this.selectedStatus.toLowerCase();

        const cat =
          this.selectedType === "All"
            ? ""
            : this.selectedType.toLowerCase();

        const bussId = JSON.parse(sessionStorage.getItem("myBuss"))?.buss_id || "";

        const params = new URLSearchParams({
          camp_user: this.camp_user,
          camp_status: status,
          camp_platform: "",   // future ready
          camp_cat: cat,
          search_key: this.searchQuery,
          buss_id: bussId
        });

        const url = apiBaseUrl + "exp/campaign/export?" + params.toString();

        window.open(
          url,
          "_blank",
          "noopener,noreferrer"
        );
      },
      getNeg(total, positive) {

        const t = parseInt(total) || 0;
        const p = parseInt(positive) || 0;

        return (t - p) + "";
      },
       copyLink(camp_id) {
        const url = mainBaseUrl+"review/"+camp_id;
        navigator.clipboard.writeText(url);
        this.toast.success("Link copied");
      },

       embedLink(camp_id) {
        const url = mainBaseUrl+"review/"+camp_id;
        navigator.clipboard.writeText(`<iframe 
                src="${url}" 
                width="100%" 
                height="600" 
                frameborder="0" 
                scrolling="no"
                style="border:0;border-radius:12px;overflow:hidden;"
              ></iframe>`);
        this.toast.success("Embed code copied");
      },

    async showQR(camp_id) {

  const url = mainBaseUrl + "review/" + camp_id;

  const res = await getQrUrl(url, "camp", camp_id, this.camp_user);
  if (!res.status) return;

  const qrUrl = apiBaseUrl + res.link;

  const qrCanvas = document.createElement("canvas");

  QRCode.toCanvas(qrCanvas, qrUrl, {
    width: 600,
    margin: 1,
    errorCorrectionLevel:"H",
    color: {
      dark: "#197fe6",
      light: "#ffffff"
    }
  }, (error) => {

    if (error) {
      console.error(error);
      return;
    }

    const canvas = document.createElement("canvas");
    canvas.width = 900;
    canvas.height = 1200;

    const ctx = canvas.getContext("2d");

    /* ---------- background ---------- */

    ctx.fillStyle = "#f8fafc";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    /* ---------- card ---------- */

    ctx.fillStyle = "#ffffff";
    ctx.shadowColor = "rgba(0,0,0,0.12)";
    ctx.shadowBlur = 30;
    ctx.fillRect(120, 120, 660, 920);

    ctx.shadowBlur = 0;

    /* ---------- header ---------- */

    ctx.fillStyle = "#197fe6";
    ctx.fillRect(120, 120, 660, 120);

    ctx.fillStyle = "#ffffff";
    ctx.font = "bold 42px Arial";
    ctx.textAlign = "center";
    ctx.fillText("REVIEWSFIX", 450, 195);

    /* ---------- QR ---------- */

    ctx.drawImage(qrCanvas, 240, 300, 420, 420);

    /* ---------- logo center ---------- */

    const logo = new Image();
    logo.src = "/images/logo.png";

    logo.onload = () => {

      ctx.fillStyle = "#ffffff";
      ctx.beginPath();
      ctx.arc(450, 510, 70, 0, Math.PI * 2);
      ctx.fill();

      ctx.drawImage(logo, 400, 460, 100, 100);

      /* ---------- stars ---------- */

      ctx.fillStyle = "#fbbf24";
      ctx.font = "34px Arial";
      ctx.fillText("★★★★★", 450, 770);

      /* ---------- CTA ---------- */

      ctx.fillStyle = "#111";
      ctx.font = "bold 36px Arial";
      ctx.fillText("Scan to Leave a Review", 450, 840);

      ctx.fillStyle = "#64748b";
      ctx.font = "24px Arial";
      ctx.fillText("Your feedback helps us grow", 450, 890);

      /* ---------- footer brand ---------- */

      ctx.fillStyle = "#197fe6";
      ctx.font = "bold 26px Arial";
      ctx.fillText("Powered by Reviewsfix", 450, 980);

      /* ---------- download ---------- */

      const link = document.createElement("a");
      link.download = `reviewsfix-qr-${camp_id}.png`;
      link.href = canvas.toDataURL("image/png");
      link.click();

      if (this.$toast) {
        this.$toast.success("Branded QR downloaded");
      }

    };

  });

},

     shareLink(camp_id) {
        const url = mainBaseUrl+"review/"+camp_id;
        if (navigator.share) {
          navigator.share({
            title: "Referral Link",
            text: "Check out this referral link",
            url: url
          })
          .catch(err => {
            console.log("Share cancelled", err);
          });

        } else {

          navigator.clipboard.writeText(url);

          if (this.$toast) {
            this.$toast.success("Link copied. You can now paste & share.");
          } else {
            alert("Link copied. You can now paste & share.");
          }
        }
      },
      /* ================= LOAD KPIs ================= */

      async loadKpis() {
        const res = await getCampaignKpiStats(this.camp_user);

        if (!res.status) return;

        this.kpis = res.data;
        this.totalCampaigns = parseInt(res.data.total_sent);
      },

      /* ================= LOAD CAMPAIGNS ================= */

      async loadCampaigns(newPage = this.page) {

        this.page = newPage;

        const status =
          this.selectedStatus === "All"
            ? ""
            : this.selectedStatus.toLowerCase();   // ⭐ CI4 expects lowercase

        const cat =
          this.selectedType === "All"
            ? ""
            : this.selectedType.toLowerCase();     // review / referral

        const offset = (this.page).toString();

        const res = await getCampaignList(
          this.camp_user,
          status,
          "",             // platform (future ready)
          cat,
          this.searchQuery,
          offset
        );

        if (!res.status) return;

        this.campaigns = res.campaigns;
      },

      /* ================= STATUS UPDATE ================= */

      async changeStatus(camp, status) {

        const res = await updateCampaignStatus(
          camp.camp_id,
          status
        );

        if (!res.status) return;

        camp.camp_status = status;
        this.activeMenuPopup = null;
      },

      /* ================= PAGINATION ================= */

      nextPage() {
        if (this.page + 1 >= this.totalPages) return;
        this.loadCampaigns(this.page + 1);
      },

      prevPage() {
        if (this.page === 0) return;
        this.loadCampaigns(this.page - 1);
      },

      /* ================= UI ================= */

      add_camp() {
        window.location.href = "/campaign/new";
      },

      toggleTypeDropdown() {
        this.activePopup = this.activePopup === "type" ? null : "type";
      },

      toggleStatusDropdown() {
        this.activePopup = this.activePopup === "status" ? null : "status";
      },

      toggleMenu(id) {
        this.activeMenuPopup = this.activeMenuPopup === id ? null : id;
      },

      async selectType(val) {
        this.selectedType = val;
        this.activePopup = null;
        this.page = 0;
        await this.loadCampaigns();
      },

      async selectStatus(val) {
        this.selectedStatus = val;
        this.activePopup = null;
        this.page = 0;
        await this.loadCampaigns();
      },

      handleOutsideClick(e) {
        if (!this.$el.contains(e.target)) {
          this.activePopup = null;
          this.activeMenuPopup = null;
        }
      },

      /* ================= HELPERS ================= */

      debounce(fn, delay) {
        let timer;

        return (...args) => {
          clearTimeout(timer);
          timer = setTimeout(() => fn(...args), delay);
        };
      }

    }
  };
</script>
<style scoped>
  .reviews-page {
    padding: 28px;
    display: flex;
    flex-direction: column;
    gap: 18px;
  }

  
  .page-title h1 {
    font-size: 28px;
    font-weight: 800;
    color: #0f172a;
  }

  .page-title p {
    font-size: 14px;
    color: #64748b;
  }


  /* METRICS */
  .metrics-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 14px;
  }

  .metric-card {
    background: white;
    border-radius: 14px;
    padding: 16px;
    border: 1px solid #e2e8f0;
  }

  .metric-head {
    display: flex;
    justify-content: space-between;
    font-size: 13px;
    color: #64748b;
  }

  .metric-value {
    font-size: 22px;
    font-weight: 800;
    margin-top: 6px;
    display: flex;
    gap: 10px;
  }

  .positive {
    color: #16a34a;
  }

  .danger {
    color: #ef4444;
  }

  .warning {
    color: #f59e0b;
  }

  .primary {
    color: #197fe6;
  }

  .neutral {
    color: #94a3b8;
  }

  /* TOOLBAR */
  .toolbar {
    background: white;
    padding: 12px;
    border-radius: 14px;
    border: 1px solid #e2e8f0;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 10px;
  }

  .search-box {
    background: #f1f5f9;
    border-radius: 10px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    gap: 6px;
    height: 38px;
  }

  .search-box input {
    border: none;
    background: transparent;
    outline: none;
  }

  .filter-btn {
    height: 38px;
    padding: 0 12px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    background: #f8fafc;
  }

  /* TABLE */
  .table-card {
    background: white;
    border-radius: 16px;
    border: 1px solid #e2e8f0;
    overflow-x: auto;
  }

  table {
    width: 100%;
    min-width: 900px;
  }

  th {
    font-size: 11px;
    text-transform: uppercase;
    color: #64748b;
    padding: 14px;
  }

  td {
    padding: 16px 14px;
    font-size: 14px;
  }

  .customer-cell {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .avatar {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: #197fe6;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 700;
  }

  .stars .filled {
    color: #f59e0b;
  }

  .platform {
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 700;
  }

  .platform.google {
    background: #fef2f2;
    color: #dc2626;
  }

  .platform.facebook {
    background: #eff6ff;
    color: #2563eb;
  }

  .status {
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 700;
  }

  .status.pending {
    background: #fef9c3;
  }

  .status.replied {
    background: #dcfce7;
  }

  .status.flagged {
    background: #fee2e2;
  }

  .pagination {
    padding: 14px;
    border-top: 1px solid #e2e8f0;
    display: flex;
    justify-content: space-between;
  }

  /* MOBILE */
  @media(max-width:768px) {
    .reviews-page {
      padding: 16px;
    }

    table {
      min-width: 700px;
    }
  }

  /* ================= PAGE STRUCTURE ================= */

  .reviews-page {
    padding: 28px;
    display: flex;
    flex-direction: column;
    gap: 18px;
    background: #f6f7f8;
  }

  /* ================= METRICS STRIP ================= */

  .metrics-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 14px;
  }

  .metric-card {
    background: white;
    border-radius: 16px;
    padding: 18px;
    border: 1px solid #e2e8f0;
    transition: 0.2s;
  }

  .metric-card:hover {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.04);
  }

  .metric-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    font-weight: 600;
    color: #64748b;
  }

  .metric-value {
    font-size: 26px;
    font-weight: 800;
    margin-top: 6px;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .metric-value small {
    font-size: 12px;
    font-weight: 700;
    display: flex;
    align-items: center;
    gap: 2px;
  }

  .metric-value .material-symbols-outlined {
    font-size: 16px;
  }

  /* ================= TOOLBAR ================= */

  .toolbar {
    background: white;
    padding: 12px;
    border-radius: 16px;
    border: 1px solid #e2e8f0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
  }

  .toolbar-left,
  .toolbar-right {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }

  /* SEARCH */

  .search-box {
    background: #f1f5f9;
    border-radius: 12px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    gap: 6px;
    height: 40px;
    min-width: 260px;
  }

  .search-box span {
    font-size: 18px;
    color: #94a3b8;
  }

  .search-box input {
    border: none;
    background: transparent;
    outline: none;
    font-size: 13px;
    width: 100%;
  }

  /* FILTER BUTTONS */

  .filter-btn {
    height: 40px;
    padding: 0 14px;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    background: #f8fafc;
    font-size: 13px;
    font-weight: 600;
    color: #334155;
    display: flex;
    align-items: center;
    gap: 6px;
    transition: 0.2s;
  }

  .filter-btn:hover {
    background: #f1f5f9;
  }

  /* ACTION BUTTONS */

  .ghost-btn {
    height: 40px;
    padding: 0 16px;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    background: white;
    font-size: 13px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .primary-btn {
    height: 40px;
    padding: 0 18px;
    border-radius: 12px;
    border: none;
    background: #197fe6;
    color: white;
    font-size: 13px;
    font-weight: 700;
    display: flex;
    align-items: center;
    gap: 6px;
    transition: 0.2s;
  }

  .primary-btn:hover {
    background: #166fd1;
  }

  /* ================= TABLE CARD ================= */

  .table-card {
    background: white;
    border-radius: 18px;
    border: 1px solid #e2e8f0;
    overflow: hidden;
  }

  /* TABLE */

  .table-card table {
    width: 100%;
    border-collapse: collapse;
  }

  .table-card thead {
    background: #f8fafc;
  }

  .table-card th {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    color: #64748b;
    text-align: left;
    padding: 14px;
    letter-spacing: 0.4px;
  }

  .table-card td {
    padding: 16px 14px;
    font-size: 14px;
    border-top: 1px solid #f1f5f9;
    vertical-align: middle;
  }

  /* ROW HOVER */

  .table-card tbody tr:hover {
    background: #f8fafc;
  }

  /* CUSTOMER CELL */

  .customer-cell {
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: 600;
  }

  .avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: #197fe6;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 700;
    flex-shrink: 0;
  }

  /* STARS */

  .stars {
    display: flex;
    gap: 2px;
  }

  .stars .material-symbols-outlined {
    font-size: 18px;
    color: #e2e8f0;
  }

  .stars .filled {
    color: #f59e0b;
  }

  /* PLATFORM BADGES */

  .platform {
    padding: 5px 12px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 700;
    white-space: nowrap;
  }

  .platform.google {
    background: #fef2f2;
    color: #dc2626;
  }

  .platform.facebook {
    background: #eff6ff;
    color: #2563eb;
  }

  /* REVIEW TEXT */

  .review-text {
    color: #334155;
    max-width: 380px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* STATUS BADGES */

  .status {
    padding: 5px 12px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 700;
  }

  .status.pending {
    background: #fef9c3;
    color: #854d0e;
  }

  .status.replied {
    background: #dcfce7;
    color: #166534;
  }

  .status.flagged {
    background: #fee2e2;
    color: #991b1b;
  }

  /* ACTION BUTTON */

  .mini-btn {
    width: 34px;
    height: 34px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    background: white;
    font-size: 16px;
    cursor: pointer;
  }

  .mini-btn:hover {
    background: #f8fafc;
  }

  /* ================= PAGINATION ================= */

  .pagination {
    padding: 16px;
    border-top: 1px solid #f1f5f9;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    color: #64748b;
    flex-wrap: wrap;
    gap: 10px;
  }

  .pages {
    display: flex;
    gap: 6px;
  }

  .pages button {
    width: 34px;
    height: 34px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    background: white;
    font-size: 13px;
    font-weight: 600;
  }

  .pages button.active {
    background: #197fe6;
    color: white;
    border-color: #197fe6;
  }

  /* ================= MOBILE RESPONSIVE ================= */

  @media (max-width: 768px) {

    .reviews-page {
      padding: 16px;
      gap: 14px;
    }

    .metrics-grid {
      grid-template-columns: 1fr;
    }

    .toolbar {
      flex-direction: column;
      align-items: stretch;
    }

    .toolbar-left,
    .toolbar-right {
      width: 100%;
    }

    .search-box {
      min-width: 100%;
    }

    .filter-btn,
    .ghost-btn,
    .primary-btn {
      width: 100%;
      justify-content: center;
    }

    .table-card {
      overflow-x: auto;
    }

    .review-text {
      max-width: 240px;
    }

    .pagination {
      flex-direction: column;
      align-items: flex-start;
    }

  }

  .actions-menu {
    position: absolute;
    background: white;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    padding: 6px;
    width: 140px;
    right: 20px;
    margin-top: 6px;
    z-index: 10;
  }

  .actions-menu div {
    padding: 8px 10px;
    font-size: 12px;
    cursor: pointer;
    border-radius: 8px;
  }

  .actions-menu div:hover {
    background: #f1f5f9;
  }

  .actions-menu .danger {
    color: #ef4444;
  }

  .dropdown-wrapper {
    position: relative;
  }

  .dropdown-menu {
    position: absolute;
    top: 46px;
    left: 0;
    background: white;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    width: 160px;
    padding: 6px;
    z-index: 20;
  }

  .dropdown-menu div {
    padding: 9px 12px;
    font-size: 13px;
    cursor: pointer;
    border-radius: 8px;
    font-weight: 500;
  }

  .dropdown-menu div:hover {
    background: #f1f5f9;
  }

  .filters-panel {
    position: absolute;
    top: 48px;
    right: 0;
    width: 240px;
    background: white;
    border-radius: 14px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
    padding: 14px;
    z-index: 50;
  }

  .filter-group {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 10px;
  }

  .filter-group label {
    font-size: 11px;
    font-weight: 700;
    color: #64748b;
    text-transform: uppercase;
  }

  .filter-group select {
    height: 36px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    padding: 0 10px;
    font-size: 13px;
    outline: none;
  }

  .filter-actions {
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
  }

  .small {
    height: 34px;
    font-size: 12px;
  }

  /* Campaign Cell */

  .campaign-cell {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .campaign-icon {
    width: 38px;
    height: 38px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
  }

  .campaign-icon.review {
    background: #eef2ff;
    color: #4f46e5;
  }

  .campaign-icon.referral {
    background: #fff7ed;
    color: #ea580c;
  }

  .campaign-info {
    display: flex;
    flex-direction: column;
  }

  .campaign-name {
    font-weight: 700;
    font-size: 14px;
    color: #0f172a;
  }

  .campaign-meta {
    font-size: 11px;
    color: #94a3b8;
  }

  /* Badges */

  .badge {
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 700;
  }

  .badge.review {
    background: #eef2ff;
    color: #4f46e5;
  }

  .badge.referral {
    background: #fff7ed;
    color: #ea580c;
  }

  /* Status Pills */

  .status-pill {
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 700;
  }

  .status-pill.active {
    background: #dcfce7;
    color: #166534;
  }

  .status-pill.paused {
    background: #f1f5f9;
    color: #64748b;
  }

  /* Funnel */

  .funnel-wrapper {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .funnel-bar {
    height: 6px;
    background: #e2e8f0;
    border-radius: 20px;
    overflow: hidden;
  }

  .funnel-bar div {
    height: 100%;
    background: #197fe6;
    border-radius: 20px;
  }

  .funnel-text {
    font-size: 11px;
    color: #64748b;
  }

  /* Conversion */

  .conversion-cell {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  .conversion-cell .value {
    font-weight: 700;
  }

  .positive {
    color: #16a34a;
  }

  .negative {
    color: #ef4444;
  }

  .actions-inline {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 6px;
    position: relative;
  }

  .icon-btn {
    width: 34px;
    height: 34px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: 0.15s;
  }

  .icon-btn span {
    font-size: 18px;
    color: #64748b;
  }

  .icon-btn:hover {
    background: #f8fafc;
    border-color: #cbd5f5;
  }

  .icon-btn:hover span {
    color: #197fe6;
  }

  .mini-btn {
    width: 34px;
    height: 34px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .mini-btn span {
    font-size: 18px;
    color: #64748b;
  }

  .mini-btn:hover {
    background: #f8fafc;
  }
  /* ===== MODAL ===== */

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.2s ease;
}

.modal-box {
  width: 420px;
  max-width: 90%;
  background: white;
  border-radius: 18px;
  padding: 28px;
  text-align: center;
  box-shadow: 0 25px 50px rgba(0,0,0,0.15);
  animation: scaleIn 0.2s ease;
}

.modal-icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 16px;
  border-radius: 50%;
  background: #fee2e2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-icon span {
  font-size: 28px;
  color: #dc2626;
}

.modal-box h3 {
  margin-bottom: 8px;
  font-size: 18px;
  font-weight: 700;
}

.modal-box p {
  font-size: 13px;
  color: #64748b;
  margin-bottom: 20px;
}

.modal-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
}

.danger-btn {
  height: 40px;
  padding: 0 18px;
  border-radius: 12px;
  border: none;
  background: #dc2626;
  color: white;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s;
}

.danger-btn:hover {
  background: #b91c1c;
}

/* Animations */

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes scaleIn {
  from { transform: scale(0.95); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}
.modal-large {
  width: 900px;
  max-width: 95%;
  background: white;
  border-radius: 18px;
  padding: 22px;
  box-shadow: 0 30px 60px rgba(0,0,0,0.15);
  display: flex;
  flex-direction: column;
}

.leads-table {
  width: 100%;
  border-collapse: collapse;
}

.leads-table th {
  font-size: 11px;
  text-transform: uppercase;
  color: #64748b;
  padding: 12px;
  text-align: left;
  background: #f8fafc;
}

.leads-table td {
  padding: 14px 12px;
  border-top: 1px solid #f1f5f9;
  font-size: 13px;
}

.modal-pagination {
  margin-top: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
}

.modal-pagination button {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: white;
}
/* ===== OVERLAY FIX ===== */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}

/* ===== MODAL CONTAINER ===== */
.modal-large {
  width: 1000px;
  max-width: 100%;
  max-height: 85vh;
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* ===== HEADER FIX (removes 85% margin hack) ===== */
.modal-large .modal-header {
  display: flex !important;
  justify-content: space-between;
  align-items: center;
  padding: 18px 22px;
  border-bottom: 1px solid #f1f5f9;
}

.modal-large .modal-header button {
  margin-left: 0 !important;
  border: none;
  background: none;
  font-size: 18px;
  cursor: pointer;
  color: #64748b;
}

.modal-large .modal-header button:hover {
  color: #ef4444;
}

/* ===== BODY SCROLL FIX ===== */
.modal-large .modal-body {
  flex: 1;
  overflow-y: auto;
}

/* ===== TABLE FIX ===== */
.leads-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 750px;
}

.leads-table thead {
  background: #f8fafc;
  position: sticky;
  top: 0;
  z-index: 2;
}

.leads-table th {
  padding: 14px 16px;
  font-size: 11px;
  text-transform: uppercase;
  color: #64748b;
  font-weight: 700;
  text-align: left;
}

.leads-table td {
  padding: 16px;
  border-top: 1px solid #f1f5f9;
  font-size: 13px;
  color: #334155;
  vertical-align: middle;
}

.leads-table tbody tr:hover {
  background: #f8fafc;
}

/* ===== PAGINATION FIX ===== */
.modal-pagination {
  padding: 14px 22px;
  border-top: 1px solid #f1f5f9;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  font-size: 13px;
  color: #64748b;
}

.modal-pagination button {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: white;
  cursor: pointer;
  transition: 0.2s;
}

.modal-pagination button:hover {
  background: #f1f5f9;
}

.modal-pagination button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* ===== STATUS PILL POLISH ===== */
.status-pill {
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
}

.status-pill.pending {
  background: #fef9c3;
  color: #854d0e;
}

.status-pill.completed {
  background: #dcfce7;
  color: #166534;
}

.status-pill.failed {
  background: #fee2e2;
  color: #991b1b;
}
</style>